import React from 'react';
import styles from './ModifiedLicenseForm.module.scss';
import ModifiedLicenseMessage from '../../Messages/ModifiedLicenseMessage/ModifiedLicenseMessage';
import ModifiedBuyCard from '../../../../getty/logicalComponents/ModifiedBuyCard/ModifiedBuyCard';
import Price from '../../Price/Price.tsx';
import MiniDownloadHistory from '../../MiniDownloadHistory/MiniDownloadHistory';
import LimitedUseProductsCallout from '../../LimitedUseProductsCallout/LimitedUseProductsCallout';

const ModifiedLicenseForm = () => (
  <div
    className={styles.container}
    data-test-id="modified-license-form"
  >
    <ModifiedLicenseMessage />
    <ModifiedBuyCard priced />
    <LimitedUseProductsCallout />
    <Price />
    <MiniDownloadHistory />
  </div>
);

export default ModifiedLicenseForm;
